var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntensity1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34702 18.7388C8.59002 19.7238 7.01502 19.2098 6.98502 17.9678L6.74602 8.10783C6.74008 7.87117 6.79805 7.63729 6.91381 7.43079C7.02958 7.22429 7.19887 7.05281 7.40386 6.9344C7.60886 6.81599 7.84198 6.75502 8.0787 6.75791C8.31542 6.7608 8.54698 6.82745 8.74902 6.95084L17.169 12.0878C18.229 12.7348 17.887 14.3558 16.656 14.5188L12.669 15.0458C12.323 15.0918 12.009 15.2728 11.797 15.5488L9.34702 18.7388Z",
    stroke: "#47D176",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.752H3.25M7 3.25V0.75M3.768 3.767L2 2M10.232 3.767L12 2",
    stroke: "#47D176",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntensity1);
export default __webpack_public_path__ + "static/media/intensity1.031380024b82bcd224d639baa0d42d38.svg";
export { ForwardRef as ReactComponent };